import { render, staticRenderFns } from "./DialogAction.vue?vue&type=template&id=1296be76"
import script from "./DialogAction.vue?vue&type=script&lang=js"
export * from "./DialogAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports